import { InjectionToken, Type } from "@angular/core";
import { UserToken } from "../../auth/user-token.model";
import { SelectableInput } from "../../dynamic-forms/inputs/selectable-input.model";
import { BillingItem } from "../../platform/modules/admin/billing-configuration/model/billing-item.model";
import { NlpKeywordModel } from "../../platform/modules/admin/nlp-keyword-manager/nlp-keyword.model";
import { AnalyticsItem } from "../../platform/modules/reporting/analytics-report/model/analytics-item.model";
import { ButtonAction } from "../../shared/button/button-action.model";
import { GridView } from "../../shared/grid/grid-menu/grid-views/grid-view.model";
import { GridViewsState } from "../../shared/grid/grid-menu/grid-views/grid-views-state.model";
import { ListItem } from "../../shared/list/list-item";
import { MenuItem } from "../../shared/menu/menu-item.model";
import { DropdownListItem } from "../../shared/models/dropdown-list-item";
import { LookupModel } from "../../shared/models/lookup-model";
import { Dictionary } from "../../utilities/dictionary";


export const STRING_TO_CLASS_DICTIONARY = new InjectionToken(
  "Without a mapping from a class name to a constructor, the application will break due to minification.",
  {
    providedIn: "root",
    factory: () => {
      const dictionary = new Dictionary<Type<any>>();
      dictionary.add("AnalyticsItem", AnalyticsItem);
      dictionary.add("ButtonAction", ButtonAction);
      dictionary.add("DropdownListItem", DropdownListItem);
      dictionary.add("GridView", GridView);
      dictionary.add("GridViewsState", GridViewsState);
      dictionary.add("ListItem", ListItem);
      dictionary.add("LookupModel", LookupModel);
      dictionary.add("MenuItem", MenuItem);
      dictionary.add("NlpKeywordModel", NlpKeywordModel);
      dictionary.add("SelectableInput", SelectableInput);
      dictionary.add("UserToken", UserToken);
      dictionary.add("BillingItem", BillingItem);

      return dictionary;
    },
  }
);
